import { ReactComponent as LungIcon } from '../../../../assets/icons/Lung.svg'
import { ReactComponent as HeartIcon } from '../../../../assets/icons/HeartBeat.svg'
import { ReactComponent as SkinIcon } from '../../../../assets/icons/BrightSkin.svg'
import { ReactComponent as BloodPressureIcon } from '../../../../assets/icons/BloodPressure.svg'
import { ReactComponent as BrainIcon } from '../../../../assets/icons/MentalDisorder.svg'
import { ReactComponent as MoonIcon } from '../../../../assets/icons/Moon.svg'

export const DEVICE_VITAL_COMPONENTS = {
  HEART_RATE: 'Heart Rate',
  SPO2: 'Spo2',
  BLOOD_PRESSURE_SYSTOLIC: 'Blood Pressure Systolic',
  BLOOD_PRESSURE_DIASTOLIC: 'Blood Pressure Diastolic',
  SKIN_TEMPERATURE: 'Skin Temperature',
  RESPIRATORY_RATE: 'Respiratory Rate',
  HEART_RATE_VAR: 'Heart Rate Var',
  STRESS: 'Stress',
  SLEEP: 'Sleep',
  BLOOD_GLUCOSE: 'Blood Glucose',
}

export const DEVICE_VITAL_COMPONENTS_ARRAY = [
  { label: 'Heart Rate', value: 'heartRate' },
  { label: 'Spo2', value: 'spo2' },
  { label: 'Blood Pressure Systolic', value: 'bloodPressureSystolic' },
  { label: 'Blood Pressure Diastolic', value: 'bloodPressureDiastolic' },
  { label: 'Skin Temperature', value: 'skinTemperature' },
  { label: 'Respiratory Rate', value: 'respiratoryRate' },
  { label: 'Heart Rate Var', value: 'heartRateVar' },
  { label: 'Stress', value: 'stress' },
  { label: 'Sleep', value: 'sleep' },
  { label: 'Blood Glucose', value: 'bloodGlucose' },
]

export const DEVICE_VITAL_OVERVIEW_PRORITHM: {
  key: string
  label: string
  icon: any
}[] = [
  { key: 'heartRate', label: 'Heart Rate', icon: HeartIcon },

  { key: 'spo2', label: 'Spo2', icon: LungIcon },
  {
    key: 'bloodPressureSystolic',
    label: 'Blood Pressure Systolic',
    icon: BloodPressureIcon,
  },
  {
    key: 'bloodPressureDiastolic',
    label: 'Blood Pressure Diastolic',
    icon: BloodPressureIcon,
  },
  { key: 'skinTemperature', label: 'Skin Temperature', icon: SkinIcon },
  { key: 'respiratoryRate', label: 'Respiratory Rate', icon: LungIcon },
  { key: 'heartRateVar', label: 'Heart Rate Var', icon: HeartIcon },
]

export const DEVICE_VITAL_OVERVIEW_SMART_RING: {
  key: string
  label: string
  icon: any
}[] = [
  { key: 'heartRate', label: 'Heart Rate', icon: HeartIcon },
  { key: 'spo2', label: 'Spo2', icon: LungIcon },
  { key: 'skinTemperature', label: 'Skin Temperature', icon: SkinIcon },
  { key: 'heartRateVar', label: 'Heart Rate Var', icon: HeartIcon },
  { key: 'stress', label: 'Stress', icon: BrainIcon },
  { key: 'sleep', label: 'Sleep', icon: MoonIcon },
]

// Mapping of vital keys to their names and units
export const vitalMappings = [
  { key: 'hr', name: 'Heart Beat', unit: 'BPM', safeKey: 'heartBeat' },
  { key: 'spo2', name: 'SpO2', unit: '%', safeKey: 'spo2' },
  {
    key: 'bp',
    name: 'Blood Pressure Systolic',
    unit: 'mmHg',
    safeKey: 'bpSystolic',
    subKey: 'sp',
  },
  {
    key: 'bp',
    name: 'Blood Pressure Diastolic',
    unit: 'mmHg',
    safeKey: 'bpDiastolic',
    subKey: 'dp',
  },
  {
    key: 'skt',
    name: 'Skin Temperature',
    unit: '°F',
    safeKey: 'skinTemperature',
  },
  {
    key: 'rr',
    name: 'Respiratory Rate',
    unit: 'breaths/min',
    safeKey: 'respiratoryRate',
  },
  {
    key: 'hrv',
    name: 'Heart Rate Variability',
    unit: 'ms',
    safeKey: 'heartRateVar',
  },
]

export const safeRangeKeys = {
  HEARTRATE: 'heartRate',
  SPO2: 'spo2',
  BLOODPRESSURESYSTOLIC: 'bloodPressureSystolic',
  BLOODPRESSUREDIASTOLIC: 'bloodPressureDiastolic',
  SKINTEMPERATURE: 'skinTemperature',
  RESPIRATORYRATE: 'respiratoryRate',
  HEARTRATEVAR: 'heartRateVar',
  STRESS: 'stress',
  SLEEP: 'sleep',
  BLOODGLUCOSE: 'bloodGlucose',
}

// Function to determine color based on value range
export const getColor = (
  safeRanges: Record<string, { min: number; max: number }>,
  key: string,
  value: number | string
) => {
  if (typeof value !== 'number') return 'black'

  const range = safeRanges[key]
  if (!range) return 'black'

  return value < range.min || value > range.max ? 'red' : 'green'
}

// Function to determine color based on value range for Icons
export const getIconColor = (
  safeRanges: Record<string, { min: number; max: number }>,
  key: string,
  value: number | string
) => {
  if (
    typeof value !== 'number' ||
    value === null ||
    value === undefined ||
    isNaN(value) ||
    value === 0
  )
    return 'grey'

  const range = safeRanges[key]
  if (!range) return 'grey'
  return value < range.min || value > range.max ? 'red' : 'green'
}

export const DATE_DIRECTIONS = {
  NEXT: 'next',
  PREVIOUS: 'prev',
}

export const GRAPH_PERIODS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
}

export const VITAL_KEYS = {
  HEART_RATE: 'heartRate',
  HRV: 'hrv',
  SKIN_TEMP: 'temperature',
  SLEEP_TRACKING: 'sleep',
  SPO2: 'spo2',
  STRESS: 'stress',
  BLOOD_PRESSURE: 'bp',
  BLOOD_GLUCOSE: 'bg',
}

export const ERROR_DEVICES_SCREEN =
  'Please Select the Patient to acccess devices'

export const backgroundImage =
  'data:image/svg+xml;base64,' +
  btoa(`
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
      <defs>
        <pattern id="smallGrid" width="10" height="10" patternUnits="userSpaceOnUse">
          <path d="M 10 0 L 0 0 0 10" fill="none" stroke="#ddd" stroke-width="0.5"/>
        </pattern>
        <pattern id="grid" width="50" height="50" patternUnits="userSpaceOnUse">
          <rect width="50" height="50" fill="url(#smallGrid)"/>
          <path d="M 50 0 L 0 0 0 50" fill="none" stroke="#aaa" stroke-width="1"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)" />
    </svg>
  `)

export const VISIT_STATUS_FINISHED = 'finished'
export const BLOOD_PRESSURE_TYPES = {
  SYSTOLIC: 'Blood Pressure Systolic',
  DIASTOLIC: 'Blood Pressure Diastolic',
}
